import { Pump } from "@/types/pump";

export function getPumpName(pump: Pump, index?: number) {
    let pumpName = "";
    if (pump.system_type === 3) {
        pumpName = `${pump.pump_make ?? ""} Pump ${
            index ? index + 1 : ""
        } (Constant)`;
    } else if (pump.system_type === 2) {
        pumpName = `${pump.pump_model ?? ""} ${pump.pump_serial_number ?? ""} (VRF)`;
    }
    return pumpName;
}
